import { mutationTypes, actionTypes } from 'BASE/store/types'
import signalr from 'BASE/common/signalrAdapter'
import CONSTANT from 'BASE/common/chat/chat.constant';
import UTIL from 'BASE/common/chat/chat.util';
import transform from 'BASE/common/chat/chat.transformServerName'
import chatSound from 'BASE/common/chat/chat.sound'

export default class RegisterSignalrCallback {
    constructor() {
        this.registerAll = (vue) => {
            signalr.addWorkOnConnected(() => {
                signalr.chatClient.clearAllHandlers();
                signalr.instantMessageClient.clearAllHandlers();
                for (let name of Object.getOwnPropertyNames(Object.getPrototypeOf(this))) {
                    let method = this[name];
                    // Supposedly you'd like to skip constructor
                    if ((method instanceof Function) === false || method === RegisterSignalrCallback) {
                        continue;
                    }
                    method(vue);
                    //console.log(method, name);
                }
            })
        };
    }

    onConnectionStateChanged(vue) {
        signalr.onConnectionStateChanged(function (oldState, newState) {
            vue.$store.dispatch(actionTypes.CHAT_SIGNALR_STATE_CHANGED, {
                oldState: oldState,
                newState: newState,
            });
        });
    }

    onReceiveMessage(vue) {
        signalr.chatClient.receiveMessageAdapter.addHandler(function (input) {
            vue.$store.dispatch(actionTypes.CHAT_RECEIVE_MESSAGE, input);
        });
        signalr.chatClient.receiveMessageAdapter.addHandler(function (input) {
            let isChatSoundEnabled = vue.$store.state.userinfo.alerts.isChatEnabled;
            // 沒有開啟視窗就增加未讀訊息數量
            let chatState = vue.$store.state.chat;
            let roomWindow = chatState.roomWindows.find(item => item.room.id === input.RoomId);
            if (!roomWindow || !roomWindow.showTime) {
                // 非自己送的訊息才需增加未讀訊息數量
                if (input.UserId !== chatState.userId) {
                    chatSound.sound(isChatSoundEnabled);
                }
            }
        });
    }

    onRemoveMessage(vue) {
        signalr.chatClient.removeMessageAdapter.addHandler(function (input) {
            vue.$store.commit(mutationTypes.CHAT_REMOVE_ROOM_MESSAGE, {
                roomId: input.RoomId,
                messageId: input.MessageId,
            });
        });
    }

    onChangeOnlineState(vue) {
        signalr.chatClient.changeOnlineStateAdapter.addHandler(function (input) {
            vue.$store.commit(mutationTypes.CHAT_SET_ROOM_ONLINE_STATE, {
                roomId: input.RoomId,
                isOnline: input.IsOnline,
            });
        });
    }

    onClearHistoryMessage(vue) {
        signalr.chatClient.clearHistoryMessageAdapter.addHandler(function (input) {
            vue.$store.dispatch(actionTypes.CHAT_RECEIVE_HISTORY_MESSAGE_CLEAR_TIME, {
                roomId: input.RoomId,
                timestamp: input.Timestamp,
            });
        });
    }

    onStartCustomerServiceServing(vue) {
        signalr.chatClient.startCustomerServiceServingAdapter.addHandler(function (input) {
            vue.$store.dispatch(actionTypes.CHAT_START_CUSTOMER_SERVICE_SERVING, { 
                sessionId: input.SessionId,
                isAlreadyRating: false
            });
        });
    }

    onFinishCustomerServiceServing(vue) {
        signalr.chatClient.finishCustomerServiceServingAdapter.addHandler(function (input) {
            vue.$store.dispatch(actionTypes.CHAT_FINISH_CUSTOMER_SERVICE_SERVING);
        });
    }

    onAddRoom(vue) {
        signalr.chatClient.addRoom.addHandler(function (input) {
            input.forEach((room) => {
                vue.$store.commit(mutationTypes.CHAT_ADD_ROOM, {
                    room: transform.transformRoom(room),
                    members: room.Members.map((item) => transform.transformRoomMember(item)),
                });
            });
        });
    }

    onRemoveRoom(vue) {
        signalr.chatClient.removeRoom.addHandler(function (input) {
            vue.$store.commit(mutationTypes.CHAT_REMOVE_ROOM, {
                roomId: input.RoomId,
            });
        });
    }

    onChangeRoomName(vue) {
        signalr.chatClient.changeRoomName.addHandler(function (input) {
            vue.$store.commit(mutationTypes.CHAT_CHANGE_ROOM_NAME, {
                roomId: input.RoomId,
                roomName: input.Name,
            });
        });
    }

    onAddRoomMember(vue) {
        signalr.chatClient.addRoomMember.addHandler(function (input) {
            input.Members.forEach((m) => {
                vue.$store.commit(mutationTypes.CHAT_ADD_ROOM_MEMBER, {
                    roomId: input.RoomId,
                    member: transform.transformRoomMember(m),
                });
            });
        });
    }

    onRemoveRoomMember(vue) {
        signalr.chatClient.removeRoomMember.addHandler(function (input) {
            input.Members.forEach((m) => {
                vue.$store.commit(mutationTypes.CHAT_REMOVE_ROOM_MEMBER, {
                    roomId: input.RoomId,
                    userId: m.HashUserId,
                });
            });
        });
    }

    onChangeRoomAnnouncement(vue) {
        signalr.chatClient.changeRoomAnnouncement.addHandler(function (input) {
            vue.$store.commit(mutationTypes.CHAT_CHANGE_ROOM_ANNOUNCEMENT, {
                roomId: input.RoomId,
                announcement: input.Announcement,
            });
        });
    }

    onReceiveInstantMessage(vue) {
        signalr.instantMessageClient.receiveMessage.addHandler((result) => {
            vue.$store.dispatch(actionTypes.CHAT_RECEIVE_MESSAGE, {
                RoomId: UTIL.getRoomId(CONSTANT.serverRoomType.SYSTEM, vue.$store.state.chat.userId),
                MessageId: result.ID,
                Content: result.Content,
                Type: CONSTANT.messageType.TEXT,
                Name: result.Title,
                Timestamp: result.CreateTime,
            })
        });
    }

    onUpdateRoomReadOnly(vue) {
        signalr.chatClient.updateRoomReadOnly.addHandler(function (input) {
            vue.$store.commit(mutationTypes.CHAT_UPDATE_GROUP_ROOM_READONLY, {
                roomId: input.RoomId,
                groupReadOnly: input.IsReadOnly,
            });
        });
    }

    onUpdateRoomMemberReadOnly(vue) {
        signalr.chatClient.updateRoomMemberReadOnly.addHandler(function (input) {
            input.Members.forEach((m) => {
                vue.$store.commit(mutationTypes.CHAT_UPDATE_GROUP_ROOM_MEMBER_READONLY, {
                    roomId: input.RoomId,
                    member: transform.transformRoomMember(m),
                    groupReadOnly: input.GroupReadOnly
                });
            });
        });
    }

    onSetRoomMemberRole(vue) {
        signalr.chatClient.setRoomMemberRole.addHandler(function (input) {
            input.Members.forEach((m) => {
                vue.$store.commit(mutationTypes.CHAT_SET_GROUP_ROOM_MEMBER_ROLE, {
                    roomId: input.RoomId,
                    member: transform.transformRoomMember(m)
                });
            });
        });
    }

    onEnterSiteGroupRoom(vue) {
        signalr.chatClient.enterSiteGroupRoom.addHandler(function (input) {
            vue.$store.commit(mutationTypes.CHAT_SITE_GROUP_UPDATE_ENTER_ROOM_USERNAME, {
                name: input.Name
            });
        });
    }

    onUpdatePinMessage(vue) {
        signalr.chatClient.updatePinMessage.addHandler(function (input) {
            vue.$store.commit(mutationTypes.CHAT_UPDATE_PIN_MESSAGE, {
                roomId: input.RoomId,
                pinMessageId: input.MessageId,
            });
        });
    }
}
